/**
 * @generated SignedSource<<abcc6961517487b21d7408e8b5ea3815>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStepChargesDisclaimer_transaction$data = {
  readonly isNegotiable: boolean | null;
  readonly isShippingKnownAtCheckout: boolean | null;
  readonly mostRecentOffer: {
    readonly quantity: number | null;
  } | null;
  readonly " $fragmentType": "CheckoutReviewStepChargesDisclaimer_transaction";
};
export type CheckoutReviewStepChargesDisclaimer_transaction$key = {
  readonly " $data"?: CheckoutReviewStepChargesDisclaimer_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStepChargesDisclaimer_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStepChargesDisclaimer_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isShippingKnownAtCheckout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Offer",
      "kind": "LinkedField",
      "name": "mostRecentOffer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "32de0c1f2cd5c0df79d7cf32ddb839df";

export default node;
